export enum EntityType {
    Producer = 1,
    Firm = 2,
    License = 3,
    Appointment = 4
}
